module.exports = __webpack_public_path__ + "img/chatbotspl_logo_white.d6f7bf43.png";